import WithRender from "../../templates/imageEditor/corners.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getCorners", "getPOIEVariables"]),
    getCornersh: function () {
      return this.getCorners.corners;
    },
    enableCorners: function () {
      return parseFloat(this.getPOIEVariables.enableCorners);
    }
  },
  methods: {
    onEnter: function (event) {
      event.preventDefault();
    },
    changeCornerStatus: function (event, corner_code) {
      this.$store.commit("changeCornerStatus", corner_code);
    },
    changeActiveItem: function (event, corner_code, index) {
      this.$store.commit("changeActiveItem", {
        corner_code: corner_code,
        index: index
      });
    }
  }
});
